<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>cloud_download</mat-icon>
				<span>Dokumente</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bInProgress" />

			@if( bAdmin ) {

				<div class="topButtons">
	
					<button
						mat-raised-button
						color="primary"
						[disabled]="bUploading || bInProgress"
						(click)="createFolder()"
					>
	
						<span
							class="material-icons"
							style="vertical-align: text-top; margin-right: .5em"
						>
							create_new_folder
						</span>
	
						<span>
							Ordner erstellen
						</span>
	
					</button>
	
					<button
						mat-raised-button
						color="primary"
						[disabled]="bUploading || bInProgress"
						(click)="folderPath=''; fileInput.click()"
					>
		
						<span
							class="material-icons"
							style="vertical-align: text-top; margin-right: .5em"
						>
							upload
						</span>
		
						<span>
							Hochladen
						</span>
		
					</button>
	
				</div>
				
			}

		</div>

		<input
			type="file"
			hidden
			#fileInput
			[attr.multiple]="true"
			accept="''"
			(change)="onFileInputAdd($event.target)"
		>

		<div class="treeContainer">

			@if( !tree.subBranches.length && !bInProgress ) {
				<div class="noElements">
					Ihrem Konto sind keine Dokumente zugeordnet
				</div>
			}

			@if( tree.subBranches.length ) {
				<div style="padding:1em; margin: 0 auto;">
	
					@for( subBranch of tree.subBranches; track subBranch.folder.hash ) {
						<app-branch-display
							[branch]="subBranch"
						/>
					}
	
				</div>
			}

		</div>

	</div>

</div>
